import { css, unsafeCSS } from 'lit';
import styles from './textarea-style.scss?inline';
import { ATTRIBUTES } from '../../input/constants';
import SotbitInputStyle from '../../input/style';

export default class SotbitTextareaStyle extends SotbitInputStyle {
    static styles = [
        SotbitInputStyle.styles,
        css`
            ${unsafeCSS(styles)}
        `,
    ];

    static properties = {
        label: { type: String },
        helperText: { type: String, attribute: ATTRIBUTES.HELPER_TEXT },
        errorText: { type: String, attribute: ATTRIBUTES.ERROR_TEXT },
        focused: { type: Boolean, state: true },
        smallLabel: { type: Boolean, state: true },
        defaultSlot: { type: Boolean, attribute: 'default-slot' },
        defaultSlotPosition: {
            type: String,
            attribute: 'default-slot-position',
        },
        disabled: { type: Boolean, state: true },
        readonly: { type: Boolean, state: true },
        required: { type: Boolean, state: true },
    };

    constructor() {
        super();

        this.textarearesizeObserver = new ResizeObserver((entries) => {
            const width = entries[0]?.target?.style?.width;

            if (width) {
                const inputContainer = this.renderRoot.querySelector('.input-container');

                if (inputContainer) {
                    inputContainer.style.width = 'max-content';
                    this.textarearesizeObserver?.disconnect();
                }
            }
        });
    }

    connectedCallback() {
        super.connectedCallback();

        if (this.input) {
            this.textarearesizeObserver?.observe(this.input);
        }
    }

    disconnectedCallback() {
        super.disconnectedCallback();

        this.textarearesizeObserver?.disconnect();
    }

    _handleInputSlotChange(e) {
        super._handleInputSlotChange(e);

        this.textarearesizeObserver?.disconnect();
        if (this.input) {
            this.textarearesizeObserver?.observe(this.input);
        }
    }
}
